import { ALL_ARTICLES_IN_EDITION, CLEAR_ALL_CURATION_CONTENT, EMAIL_BROWSER } from 'constants/actionTypes';
import { EDITION_NAME_CHANGE } from 'constants/types';
import * as interfaces from '../../Content/interfaces';

const editionData = {
  emailId: 0,
  reset: false,
  data: Array<interfaces.IArticlesItem>(),
  loading: true,
  editionArticlesLoading: false,
  editionArticles: Array<interfaces.IArticlesItem>(),
  curatedCount: 0,
  editionName: '',
  digestName: '',
  campaignName: '',
  templateId: 0,
  editionStatus: '',
  userId: 0,
  adminId: 0,
  assetId: 0,
  editionId: 0,
  editionLastUpdate: '',
  workflowCurrentState: '',
  workflowStatus: '',
  workflowId: 0,
  subject: '',
  emailType: -1,
  noCampaign: false,
  page: 0,
  workflowName: '',
  addArticle: {
    loading: false,
    success: false,
    failed: false,
    message: '',
    alreadyAdded: false,
  },
  nameChange: {
    loading: false,
    success: false,
    fail: false,
  },
  subjectChange: {
    loading: false,
    success: false,
    fail: false,
  },
  articlesUpdated: false, //* for handling of articles remove/add
};

export const editionDataReducer = (state = editionData, action: interfaces.IArticlesAction) => {
  let newState = { ...state };

  switch (action.type) {
    case ALL_ARTICLES_IN_EDITION.SET_EMAIL_ID:
      newState.emailId = action.payload;
      return newState;
    case ALL_ARTICLES_IN_EDITION.LOAD_SUCCESS:
      newState.editionArticlesLoading = false;
      newState.editionArticles = [...action.payload.list];
      newState.curatedCount = action.payload?.list?.length;
      newState.editionName = action.payload.editionName;
      newState.digestName = action.payload.digestName;
      newState.campaignName = action.payload.campaignName;
      if (!action.payload.digestName) newState.noCampaign = true;
      newState.templateId = action.payload.templateId;
      newState.editionStatus = action.payload.editionStatus;
      newState.userId = action.payload.userId;
      newState.adminId = action.payload.adminId;
      newState.assetId = action.payload.assetId;
      newState.editionId = action.payload.editionId;
      newState.subject = action.payload.subject;
      newState.emailType = action.payload.emailType;
      newState.editionLastUpdate = action.payload.editionLastUpdate;
      newState.workflowCurrentState = action.payload.workflowCurrentState;
      newState.workflowStatus = action.payload.workflowStatus;
      newState.workflowId = action.payload.workflowId;
      newState.workflowName = action.payload.workflowName;
      return newState;
    case ALL_ARTICLES_IN_EDITION.LOAD:
      newState.editionArticlesLoading = true;
      return newState;
    case ALL_ARTICLES_IN_EDITION.SUBJECT_UPDATE:
      const editionName = action.payload.editionName;
      const editionSubject = action.payload.subject;
      if (editionName) {
        newState.editionName = editionName;
      }
      if (editionSubject) {
        newState.subject = editionSubject;
      }

      return newState;
    case ALL_ARTICLES_IN_EDITION.LOAD_FAIL:
      newState.editionArticlesLoading = false;
      return newState;
    case ALL_ARTICLES_IN_EDITION.TEMPLATE_ID_UPDATE:
      newState.templateId = action.payload;
      return newState;

    case ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_LOAD:
      newState.addArticle.loading = true;
      newState.addArticle.success = false;
      newState.addArticle.alreadyAdded = false;
      newState.addArticle.failed = false;
      newState.addArticle.message = '';
      return newState;

    case ALL_ARTICLES_IN_EDITION.REMOVE_ARTICLE:
      newState.editionArticlesLoading = false;
      let index = newState.editionArticles.findIndex((x) => x.id === action.payload.articleId);
      newState.editionArticles = [
        ...newState.editionArticles.slice(0, index),
        ...newState.editionArticles.slice(index + 1),
      ];
      return newState;

    case ALL_ARTICLES_IN_EDITION.REMOVE_ALL_ARTICLES:
      newState.editionArticlesLoading = false;
      newState.editionArticles = [];
      return newState;

    case ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_SUCCESS:
      // for appending the last article at tome
      newState.editionArticles.unshift(action.payload.list);
      newState.curatedCount += 1;
      newState.addArticle.success = true;
      newState.addArticle.loading = false;
      newState.addArticle.alreadyAdded = false;
      newState.addArticle.failed = false;
      return newState;

    case ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_FROM_FAVORITES:
      action.payload.is_curated = true;
      action.payload.isFavorites = true;
      newState.editionArticles.push(action.payload);
      newState.addArticle.success = true;
      newState.addArticle.loading = false;
      newState.addArticle.alreadyAdded = false;
      newState.addArticle.failed = false;
      return newState;

    case ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_ALREADY_ADDED:
      newState.addArticle.success = true;
      newState.addArticle.loading = false;
      newState.addArticle.alreadyAdded = true;
      newState.addArticle.failed = false;
      newState.addArticle.message = action.payload.message;
      return newState;
    case ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_FAILED:
      newState.addArticle.success = false;
      newState.addArticle.loading = false;
      newState.addArticle.failed = true;
      newState.addArticle.message = action.payload.message;
      return newState;
    case ALL_ARTICLES_IN_EDITION.RESET_ARTICLE_STATE:
      newState.addArticle.success = false;
      newState.addArticle.loading = false;
      newState.addArticle.failed = false;
      newState.addArticle.message = '';
      newState.addArticle.alreadyAdded = false;
      return newState;

    case ALL_ARTICLES_IN_EDITION.UPDATE_CURATED_COUNT:
      newState.curatedCount += action.payload;
      return newState;

    case ALL_ARTICLES_IN_EDITION.UPDATE_ARTICLES_AND_COUNT:
      let articles_ids = action.payload.articles_ids;
      newState.editionArticles = newState.editionArticles.filter((item) => articles_ids.includes(item.id));
      newState.curatedCount = newState.editionArticles.length;
      return newState;

    case ALL_ARTICLES_IN_EDITION.RESET_ALL_DATA:
      newState.editionArticles = [];
      newState.data = [];
      newState.curatedCount = 0;
      newState.emailType = -1;
      newState.editionStatus = '';
      return newState;

    case ALL_ARTICLES_IN_EDITION.RESET_DATA:
      newState.editionArticles = [];
      newState.data = [];
      return newState;

    case ALL_ARTICLES_IN_EDITION.RESET:
      return { ...editionData };

    case ALL_ARTICLES_IN_EDITION.REORDER:
      newState.editionArticles = action.payload;
      return newState;

    // change name when trigger from EmailBrowser or Header
    case EMAIL_BROWSER.SET_EMAIL_NAME:
      let email_id = action.payload.emailId;
      let name = action.payload.emailName;
      if (email_id.toString() === newState.editionId.toString()) newState.editionName = name;
      return newState;

    // Name change service
    case EDITION_NAME_CHANGE.LOAD:
      newState.nameChange.loading = true;
      return newState;
    case EDITION_NAME_CHANGE.SUCCESS:
      newState.nameChange.loading = false;
      newState.nameChange.success = true;
      newState.editionName = action.payload;
      return newState;
    case EDITION_NAME_CHANGE.FAIL:
      newState.nameChange.loading = false;
      newState.nameChange.fail = true;
      return newState;
    case EDITION_NAME_CHANGE.RESET:
      newState.nameChange.loading = false;
      newState.nameChange.success = false;
      newState.nameChange.fail = false;
      return newState;
    case EDITION_NAME_CHANGE.ASSET_NAME_UPDATE:
      newState.editionName = action.payload;
      return newState;

    case CLEAR_ALL_CURATION_CONTENT.LOAD_SUCCESS:
      newState.editionArticlesLoading = false;
      newState.editionArticles = [];
      newState.curatedCount = 0;
      return newState;
    case ALL_ARTICLES_IN_EDITION.ADD_FAVORTIE_IN_EDITIONS:
      const favArticle = newState.editionArticles.filter(
        (article) => article.id === parseInt(action.payload.articleId),
      );
      if (favArticle.length > 0) {
        favArticle[0].is_favourite = true;
      }
      newState.data = [...state.data];
      return newState;
    case ALL_ARTICLES_IN_EDITION.REMOVE_FAVORTIE_IN_EDITIONS:
      const remArticle = newState.editionArticles.filter(
        (article) => article.id === parseInt(action.payload.articleId),
      );
      if (remArticle && remArticle[0]) remArticle[0].is_favourite = false;
      newState.data = [...state.data];
      return newState;
    // email status change on
    case ALL_ARTICLES_IN_EDITION.UPDATE_EMAIL_STATUS:
      newState.editionStatus = action.payload;
      return newState;

    case ALL_ARTICLES_IN_EDITION.RESET_ALL_EDITION_DATA:
      newState.editionArticlesLoading = false;
      newState.editionArticles = [];
      newState.curatedCount = 0;
      newState.editionName = '';
      newState.digestName = '';
      newState.campaignName = '';
      // if (!action?.payload?.digestName) newState.noCampaign = true;
      newState.templateId = -1;
      newState.editionStatus = '';
      newState.userId = 0;
      newState.adminId = 0;
      newState.assetId = 0;
      newState.editionId = 0;
      newState.subject = '';
      newState.emailType = -1;
      newState.editionLastUpdate = '';
      return newState;

    case ALL_ARTICLES_IN_EDITION.UPDATE_CAMPAIGN_STATE:
      newState.noCampaign = action.payload;
      return newState;

    case ALL_ARTICLES_IN_EDITION.UPDATE_WORKFLOW_CURRENT_STATE:
      newState.workflowCurrentState = action.payload;
      return newState;

    case ALL_ARTICLES_IN_EDITION.ARTICLES_UPDATED_FLAG:
      newState.articlesUpdated = action.payload;
      return newState;

    case ALL_ARTICLES_IN_EDITION.UPDATE_DIGEST:
      newState.digestName = action.payload.digestName;
      newState.assetId = action.payload.assetId;
      return newState;

    default:
      return state;
  }
};
